import { salonDate } from "../../../../utils/salonDate";
const toDate = (value) => {
  const date = value instanceof Date ? new Date(value.getTime()) : new Date(`${value}T00:00:00Z`);
  return Number.isNaN(date.getTime()) ? null : date;
};

const isoDate = (date) => date.toISOString().slice(0, 10);

export const defaultClientStatementDateRange = (today = new Date(), timezone = "UTC") => {
  const end = toDate(salonDate(today, timezone)) || new Date();
  const start = new Date(end.getTime());
  start.setUTCDate(start.getUTCDate() - 30);
  return { end_date: isoDate(end), start_date: isoDate(start) };
};

export const validateClientStatementDateRange = ({ start_date: startValue, end_date: endValue } = {}) => {
  const start = toDate(startValue);
  const end = toDate(endValue);
  if (!start || !end) return "Start and end dates are required.";
  if (start > end) return "Start date must be before or equal to end date.";
  const days = Math.round((end.getTime() - start.getTime()) / 86400000) + 1;
  return days > 31 ? "The statement range must contain at most 31 days." : "";
};
